import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import RightArrow from "../../svg/right-arrow";
import CloseIcon from "../../svg/close";
import useClickOutside from "../../helpers/clickOutside.helper";

const MobileDrawer = ({
  setShowMobileMenu,
  setShowMobileDropdown,
  handleClose,
  showMobileMenu,
  showMobileDropdown,
}) => {
  const mobileMenu = useRef(null);
  const firstFocusableElement = useRef(null);
  const lastFocusableElement = useRef(null);

  useClickOutside(mobileMenu, () => {
    setShowMobileMenu(false);
  });

  // Focus trap for keyboard navigation
  useEffect(() => {
    if (showMobileMenu && mobileMenu.current) {
      const focusableElements = mobileMenu.current.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      
      if (focusableElements.length > 0) {
        firstFocusableElement.current = focusableElements[0];
        lastFocusableElement.current = focusableElements[focusableElements.length - 1];
        firstFocusableElement.current.focus();
      }

      const handleTabKey = (e) => {
        if (e.key !== 'Tab') return;

        if (e.shiftKey) {
          // Shift + Tab
          if (document.activeElement === firstFocusableElement.current) {
            e.preventDefault();
            lastFocusableElement.current?.focus();
          }
        } else {
          // Tab
          if (document.activeElement === lastFocusableElement.current) {
            e.preventDefault();
            firstFocusableElement.current?.focus();
          }
        }
      };

      document.addEventListener('keydown', handleTabKey);
      return () => {
        document.removeEventListener('keydown', handleTabKey);
      };
    }
  }, [showMobileMenu]);

  return (
    <div
      className={`mobile-menu ${
        !showMobileMenu ? "mobile-menu-close" : "mobile-menu-open"
      }`}
      ref={mobileMenu}
      id="mobile-menu"
      role="navigation"
      aria-label="Mobile navigation menu"
      aria-hidden={!showMobileMenu}
    >
      <div className="mobile-menu-btns">
        {!showMobileDropdown && (
          <button
            className="close-menu"
            onClick={() => {
              setShowMobileMenu(false);
            }}
            aria-label="Close mobile menu"
            type="button"
          >
            <CloseIcon />
          </button>
        )}
      </div>
      <div className="mobile-wrap">
        <div className="nav">
          <ul className="nav-items">
            <li>
              <Link 
                to={"/#banner"} 
                className="nav-link" 
                onClick={handleClose}
                tabIndex={showMobileMenu ? 0 : -1}
              >
                Home
              </Link>
            </li>
            <li>
              <button
                className="nav-link products-dropdown"
                aria-haspopup="true"
                aria-expanded={showMobileDropdown}
                onClick={(e) => {
                  e.preventDefault();
                  setShowMobileMenu(false);
                  setShowMobileDropdown(true);
                }}
                tabIndex={showMobileMenu ? 0 : -1}
              >
                Featured Products <RightArrow fll="#000" />
              </button>
            </li>
            <li>
              <Link 
                to={"/services"} 
                className="nav-link" 
                onClick={handleClose}
                tabIndex={showMobileMenu ? 0 : -1}
              >
                Services
              </Link>
            </li>
            <li>
              <Link 
                to={"/about"} 
                className="nav-link" 
                onClick={handleClose}
                tabIndex={showMobileMenu ? 0 : -1}
              >
                About us
              </Link>
            </li>
            <li>
              <Link 
                to={"/blogs"} 
                className="nav-link" 
                onClick={handleClose}
                tabIndex={showMobileMenu ? 0 : -1}
              >
                Blog
              </Link>
            </li>
            <li>
              <Link
                to={"/contact/#contact"}
                className="nav-link"
                onClick={handleClose}
                tabIndex={showMobileMenu ? 0 : -1}
              >
                Contact us
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MobileDrawer;
